import React, {useState} from "react";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import OnboardingStages from "features/pages/account/onboarding/stages";
import ProfileEditForm from "features/forms/profile-edit";
import {connect} from "react-redux";
import {profileData, profileGetLoading} from "store/reducer/user/profile/selectors";
import {getProfileStart} from "store/reducer/user/profile/reducer";
import {func} from "prop-types";
import Loading from "features/components/loading";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: profileGetLoading(state),
    data: {
        ...profileData(state)
    },
    error: {
        inError: false,
        error: ""
    },
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getProfileStart
};

export const OnboardingProfile = (props) => {
    const {data, loading, getProfileStart, onChange} = props;
    const [profile, setProfile] = useState(data);

    React.useEffect(() => {
        getProfileStart();
    }, [getProfileStart]);

    React.useEffect(() => {
        onChange(profile);
    }, [profile, onChange]);


    return <div className={"white-box"}>
        <OnboardingStages index={0} />
        {loading ?
            <Loading /> :
            <>
                <Title size={24} align={"center"}>{__("onboarding.profile.title")}</Title>
                <Text size={16} align={"center"}>{__("onboarding.profile.text")}</Text>
                <ProfileEditForm onChange={setProfile} {...data} />
            </>}
    </div>
};
OnboardingProfile.propTypes = {
    onChange: func.isRequired
}
export default connect(mapStateToProps, mapDispatchToProps)(OnboardingProfile);